import React, { FC } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';
import { WithColor } from '@styles/colors';
import ColorWrapper from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';
import { useManageNotificationSystem } from './hooks/useManageNotificationSystem';

interface NotificationProps extends WithColor {}

const Notification: FC<NotificationProps> = ({ C }) => {
  const { needUpdateApp, goToPlayStoreConfig } = useManageNotificationSystem();

  if (!needUpdateApp) return null;

  return (
    <View
      style={{
        // flex: 1,
        width: '100%',
        height: '100%',
        gap: scale(48),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Background/Light/System [mobile]'),
        paddingHorizontal: scale(30),
      }}
    >
      <Svg icon="smartFactory" width={scale(140)} height={scale(69)} color={'Other/Light/Logo/Factory'} />
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
        {i18n.t('The Smart Factory app needs to be updated.')}
      </Text>
      <TouchableElement onPress={goToPlayStoreConfig.onPress}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              boxStyle,
              {
                backgroundColor: C(pressHoverColor('Button/Light/Login')),
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: scale(300),
                height: scale(53),
                borderRadius: scale(12),
                alignSelf: 'center',
                width: '100%',
              },
            ]}
          >
            <Text style={[font.Headline, { color: C('Button/Light/Primary Text') }]}>{i18n.t('Update')}</Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default ColorWrapper(Notification);
